import React from 'react'

function PlayerDetails(props) {
  return (
    <>
        <div className="song_details">
            <img src={props.song.image} alt={props.song.title} />
            <div className="info px-2 d-flex flex-column justify-content-start">
            <h5>{props.song.title}</h5>
            <h6 className='text-muted'>{props.song.artist}</h6>
            </div>
        </div>
    </>
  )
}

export default PlayerDetails